export default __webpack_public_path__ + "static/media/userPhoto.1d13e0bd.jpg";